var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsApi = function SvgIconsApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.111 17V7h3.874c.837 0 1.53.133 2.078.4.549.267.958.633 1.227 1.1.269.467.404.99.404 1.571 0 .553-.13 1.06-.39 1.522-.258.462-.662.833-1.21 1.114-.549.281-1.252.422-2.11.422h-1.959V17h-1.914zm1.914-5.357h1.84c.668 0 1.149-.14 1.443-.422.294-.28.441-.664.441-1.15 0-.495-.147-.883-.44-1.164-.295-.28-.776-.421-1.444-.421h-1.84v3.157zM1 17 4.829 7h2.153l3.829 10H8.777l-.838-2.314H3.857L3.004 17H1zm3.38-3.743h3.036L5.891 9.1 4.38 13.257zM21 17V7h1.914v10z"
  })));
};
export default SvgIconsApi;